<template>
  <div id="modalCreateEditDistribution" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-full">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ textModal }} Configuração de Distribuição
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <label class="form-label">
                  Quadro: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  :class="{
                    'is-invalid': v$.distribution.boardId.$errors.length,
                  }"
                  v-model="v$.distribution.boardId.$model"
                >
                  <option value="" disabled selected>
                    Selecione uma opção
                  </option>
                  <option
                    v-for="board in boards"
                    :key="board.id"
                    :value="board.id"
                  >
                    {{ board.name }}
                  </option>
                </select>
                <span
                  v-if="
                    v$.distribution.boardId.required.$invalid &&
                    v$.distribution.boardId.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label">
                  Pesquisa: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  :class="{
                    'is-invalid': v$.distribution.surveyId.$errors.length,
                  }"
                  v-model="v$.distribution.surveyId.$model"
                >
                  <option value="" disabled selected>
                    Selecione uma opção
                  </option>
                  <option
                    v-for="survey in surveys"
                    :key="survey.id"
                    :value="survey.id"
                  >
                    {{ survey.name }}
                  </option>
                </select>
                <span
                  v-if="
                    v$.distribution.surveyId.required.$invalid &&
                    v$.distribution.surveyId.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-12 col-md-12">
                <p>Dias da Semana: <span class="text-danger">*</span></p>
                <div
                  class="form-check form-check-inline mb-1"
                  v-for="(day, index) in daysOfWeekOptions"
                  :key="index"
                >
                  <input
                    type="checkbox"
                    :id="`daysofweek${day.value}`"
                    class="form-check-input cp"
                    name="daysOfWeek[]"
                    :checked="day.selected"
                    v-model="daysOfWeekOptions[index].selected"
                  />
                  <label
                    class="form-check-label cp"
                    :for="`daysofweek${day.value}`"
                  >
                    {{ day.text }}
                  </label>
                </div>
                <span
                  v-if="
                    v$.distribution.daysOfWeek.required.$invalid &&
                    v$.distribution.daysOfWeek.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label">
                  Hora do Disparo: <span class="text-danger">*</span>
                </label>
                <input
                  type="time"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.distribution.hour.$errors.length,
                  }"
                  v-model="v$.distribution.hour.$model"
                />
                <span
                  v-if="
                    v$.distribution.hour.required.$invalid &&
                    v$.distribution.hour.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label">
                  Status: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  v-model="v$.distribution.status.$model"
                >
                  <option value="" disabled selected>
                    Selecione uma opção
                  </option>
                  <option
                    v-for="option in statusOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label">
                  Reenviar Pesquisa: <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  :class="{
                    'is-invalid': v$.distribution.sendRemider.$errors.length,
                  }"
                  v-model="v$.distribution.sendRemider.$model"
                >
                  <option value="" disabled selected>
                    Selecione uma opção
                  </option>
                  <option
                    v-for="option in yesOrNoOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
                <span
                  v-if="
                    v$.distribution.sendRemider.required.$invalid &&
                    v$.distribution.sendRemider.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div
                class="col-12 col-md-6"
                v-show="distribution.sendRemider == 1"
              >
                <label class="form-label">Relembrar em (dias):</label>
                <input
                  type="number"
                  class="form-control"
                  min="1"
                  placeholder="Se não respondido, em quandos dias deve-se enviar novamente?"
                  v-model="distribution.sendRemiderDays"
                />
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label">
                  Enviar para Ticket já pesquisado:
                  <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  :class="{
                    'is-invalid': v$.distribution.sendSameTicket.$errors.length,
                  }"
                  v-model="v$.distribution.sendSameTicket.$model"
                >
                  <option value="" disabled selected>
                    Selecione uma opção
                  </option>
                  <option
                    v-for="option in yesOrNoOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
                <span
                  v-if="
                    v$.distribution.sendSameTicket.required.$invalid &&
                    v$.distribution.sendSameTicket.$errors.length
                  "
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div
                class="col-12 col-md-6"
                v-show="distribution.sendSameTicket == 1"
              >
                <label class="form-label">
                  Reenviar a partir de quantos dias (dias):
                </label>
                <input
                  type="number"
                  class="form-control"
                  min="1"
                  placeholder="A partir de quantos dias deve-se enviar novamente?"
                  v-model="distribution.sendSameTicketDays"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditDistributionModal',

  props: {
    distributionSetupId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      boards: [],
      surveys: [],
      distribution: {
        boardId: '',
        surveyId: '',
        status: 1,
        daysOfWeek: [],
        hour: '',
        sendSameTicket: '',
        sendRemider: '',
        sendRemiderDays: null,
        sendSameTicketDays: null,
      },
      daysOfWeek: [],
      statusOptions: [
        { value: 1, text: 'Ativo' },
        { value: 0, text: 'Inativo' },
      ],
      yesOrNoOptions: [
        { value: 1, text: 'Sim' },
        { value: 0, text: 'Não' },
      ],
      daysOfWeekOptions: [
        { value: 0, text: 'Domingo', selected: false },
        { value: 1, text: 'Segunda-feira', selected: false },
        { value: 2, text: 'Terça-feira', selected: false },
        { value: 3, text: 'Quarta-feira', selected: false },
        { value: 4, text: 'Quinta-feira', selected: false },
        { value: 5, text: 'Sexta-feira', selected: false },
        { value: 6, text: 'Sábado', selected: false },
      ],
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.distributionSetupId ? 'Atualizar' : 'Cadastrar'
    },
  },

  watch: {
    'daysOfWeekOptions': {
      handler() {
        this.setDayOfWeek()
      },
      deep: true,
    },
    'distribution.sendRemider': {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.distribution.sendRemiderDays = null
        }
      },
    },
    'distribution.sendSameTicket': {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.distribution.sendSameTicketDays = null
        }
      },
    },
  },

  methods: {
    async getBoardsAndSurveys() {
      try {
        this.boards = await this.$store.dispatch('getBoardsActives')
        this.surveys = await this.$store.dispatch('getSurveysActives')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async getDistributionSetup() {
      try {
        this.distribution = await this.$store.dispatch(
          'getDistributionSetup',
          this.distributionSetupId,
        )
        this.recoveryDaysOfWeek()
        showModal('modalCreateEditDistribution')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    recoveryDaysOfWeek() {
      this.daysOfWeekOptions = this.daysOfWeekOptions.map((day) => {
        return {
          ...day,
          selected: this.distribution.daysOfWeek.includes(day.value),
        }
      })
    },

    setDayOfWeek() {
      this.distribution.daysOfWeek = this.daysOfWeekOptions
        .filter((day) => day.selected)
        .map((day) => day.value)
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.distributionSetupId) {
            response = await this.$store.dispatch('updateDistributionSetup', {
              id: this.distributionSetupId,
              distributionSetup: this.distribution,
            })
          } else {
            response = await this.$store.dispatch(
              'createDistributionSetup',
              this.distribution,
            )
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      distribution: {
        boardId: {
          required,
        },
        surveyId: {
          required,
        },
        status: {
          required,
        },
        daysOfWeek: {
          required,
        },
        hour: {
          required,
        },
        sendSameTicket: {
          required,
        },
        sendRemider: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getBoardsAndSurveys()
    if (this.distributionSetupId) {
      this.getDistributionSetup()
    } else {
      showModal('modalCreateEditDistribution')
    }
  },
}
</script>
